'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider, createDndContext } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const { dragDropManager } = createDndContext(HTML5Backend);

export default function DragDropProvider({ children }) {
    return <DndProvider manager={dragDropManager}>{children}</DndProvider>;
}

DragDropProvider.propTypes = {
    children: PropTypes.node,
};
